
/*
 * Copyright (c) 2022 by Leyton Group - All Rights Reserved.
 * This source code, and resulting software, is the confidential and proprietary information
 * ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 * of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 * and shall use it only in accordance with the terms and conditions of any and all license
 * agreements you have entered into with The Company.
 */

import {reglementaireService} from "../views/Reglementaire/services";

const state = {
    articles: [],
    article: ''
};
const getters = {
    getArticles: (state) => state.articles,
    getArticle: (state) => state.article,
};
const actions = {
    getArticlesAction({ commit }, { currentPage, perPage, sortBy, sortDir }) {
        reglementaireService.fetchArticles(currentPage, perPage, sortBy, sortDir).then(
            (result) => {
                commit("setArticles", result);
            },
            (error) => {
                console.log(error);
            }
        );
    },
    getArticleByIdAction({ commit }, { id }) {
        reglementaireService.fetchArticleById(id).then(
            (result) => {
                commit("setArticle", result);
            },
            (error) => {
                console.log(error);
            }
        )
    },
};
const mutations = {
    setArticles(state, val) {
        state.articles = val;
    },
    setArticle(state, post){
        state.article = post;
    }
};

export const regulation = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
